import axios from 'axios';
import Raven from 'raven-js';

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

axios.interceptors.response.use(
  response => response,
  (error) => {
    Raven.captureException(error);
    return Promise.reject(error);
  },
);

export default axios;



// WEBPACK FOOTER //
// ./src/components/helpers/axiosConfig.js